import { Component, OnInit, ViewChild } from '@angular/core';
import { IAttivita } from '../interfaces/IAttivita';
import { DynamicDialogConfig, MenuItem, DialogService } from 'primeng/api';
import { IPagamentoAttivita } from '../interfaces/IPagamentoAttivita';
import { ISal } from '../interfaces/ISal';
import * as Moment from 'moment'
import { OverlayPanel } from 'primeng/overlaypanel';
import { IPagamento } from '../interfaces/IPagamento';
import { TranslateService } from '@ngx-translate/core';
import { AlertUtil } from '../utils/alert-util';
import { DocumentiService } from '../services/documenti.service';
import { Loading } from '../utils/loading';
import * as Enum from '../utils/enums';
import { RequestBuilder } from '../classes/request-builder';
import { finalize } from 'rxjs/operators';
import { Util } from '../utils/util';
import { AttivitaService } from '../services/attivita.service';
import { NewSalModalComponent } from '../new-sal-modal/new-sal-modal.component';

@Component({
  selector: 'app-attivita-sal-payment-modal',
  templateUrl: './attivita-sal-payment-modal.component.html',
  styleUrls: ['./attivita-sal-payment-modal.component.css']
})
export class AttivitaSalPaymentModalComponent implements OnInit {
  @ViewChild('op') op: OverlayPanel
  objSALByAttivita: IAttivita                 //obj from service
  listPagamenti: IPagamentoAttivita[]
  listSAL: ISal[]                             //SAL for attivita
  arrayDate: string[] = []                    //array of date
  arrayAvanzamento: number[] = []             //array avanzamento
  data: any                                   // for chart
  options: any                                // for chart
  itemsAllegato: MenuItem[];                  //menu item
  attachmentUrl: string = ""                  //url dell'allegato


  constructor(private config: DynamicDialogConfig,
    private translate: TranslateService,
    private alertUtil: AlertUtil,
    private dialogService: DialogService,
    private attivitaService: AttivitaService,
    private documentiService: DocumentiService) {

    this.objSALByAttivita = this.config.data.objSALByAttivita
  }

  ngOnInit() {
    this.checkObjAndSetField()
    this.getChartDat()
  }

  /**
  * check obj
  * set component for chart and html
  */
  checkObjAndSetField() {
    if (this.objSALByAttivita.rel_PagamentoAttivita) {
      this.listPagamenti = this.objSALByAttivita.rel_PagamentoAttivita
    }
    this.listSAL = this.objSALByAttivita.SAL
    let count = 0
    this.arrayAvanzamento = []
    this.arrayDate = []
    this.listSAL.forEach(item => {
      let dateFormatted: string;
      dateFormatted = this.formatDateForChart(item.Data);
      this.arrayDate.push(dateFormatted);
      this.arrayAvanzamento.push(item.Avanzamento_percentuale + count);
      count += item.Avanzamento_percentuale
    });
  }

  /**
  * format date for html
  * @param date string from service
  */
  formatDateForChart(date: any): string {
    // format date value
    let valueMoment = Moment(date, "YYYY-MM-DDTHH:mm:ssZ", true)
    if (valueMoment.isValid()) {
      date = valueMoment.format("DD/MM/YYYY")
    }
    return date
  }

  /**
   * get chart data
   */
  getChartDat() {
    this.data = {
      labels: this.arrayDate,
      datasets: [
        {
          label: this.objSALByAttivita.Nome,
          data: this.arrayAvanzamento,
          fill: false,
          borderColor: '#4bc0c0'
        }
      ]
    }
    //add € to avanzamento and tooltip
    this.options = {
      scales: {
        yAxes: [{
          stacked: true,
          ticks: {
            callback: function (value, index, values) {
              return value + "€";
            }
          }
        }]
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItems, data) {
            return data.datasets[tooltipItems.datasetIndex].label + ': ' + tooltipItems.yLabel + ' €'
          }
        }
      }
    }
  }

  /**
   * open menu for download file
   * @param menu 
   * @param sal sal selected
   * @param pagamento pagamento selected
   */
  openMenu(menu, sal: ISal, pagamento: IPagamento) {
    this.optionsAllegato(pagamento, sal)
    menu.toggle(event)
  }

  /**
   * set options open allegato
   * @param fromAttivita boolean
   * @param payment obj selected
   * @param sal obj selected
   */
  private optionsAllegato(payment: IPagamento, sal: ISal) {
    this.translate.get(["LBL_ALLEGATO_APRI", "LBL_ALLEGATO_CANCELLA",]).subscribe(res => {
      this.itemsAllegato = [
        {
          label: res["LBL_ALLEGATO_APRI"], icon: 'pi pi-download', command: () => {
            this.openAllegato(payment, sal);
          }
        }
      ];
    })
  }

  /**
   * 
   * @param payment obj selected
   * @param sal obj selected
   */
  openAllegato(payment: any, sal: any) {
    if (payment) {
      this.scaricaAllegatoPagamentoAttivita(payment)
    } else {
      this.scaricaAllegatoSALAttivita(sal)
    }
  }

  /**
   * scarica allegato pagamento attivita
   */
  scaricaAllegatoPagamentoAttivita(payment: any) {
    Loading.isLoading = true
    let requestBuilder = new RequestBuilder({
      IdPagamento: payment.Pagamento.Id
    })

    this.documentiService.visualizzaPagamentoAttivita(requestBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        this.downloadAllegato(payment, null, response);
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      }
    )
  }

  /**
   * download allegato
   */
  private downloadAllegato(payment: any, sal: any, response: any) {
    let allegatoType = payment ? payment.Estensione_allegato.trim() : sal.Estensione_allegato.trim()
    let allegatoNome = payment ? payment.NomeAllegato : sal.NomeAllegato
    if (!allegatoType) {
      allegatoType = allegatoNome.substring(allegatoNome.lastIndexOf("."));
    }
    if (allegatoType == Enum.FILE_TYPE_ENUM.PDF) {
      Util.showPdf(response);
    }
    else if (allegatoType == Enum.FILE_TYPE_ENUM.JPEG || allegatoType == Enum.FILE_TYPE_ENUM.JPG
      || allegatoType == Enum.FILE_TYPE_ENUM.PNG) {
      this.attachmentUrl = "data:image/" + allegatoType + ";base64," + response;
      //Apertura dell'overlay panel
      this.op.toggle(event);
    }
    else {
      Util.downloadFile(response, allegatoType, allegatoNome);
    }
  }

  /**
   * scarica allegato pagamento attivita
   */
  scaricaAllegatoSALAttivita(sal: any) {
    Loading.isLoading = true
    let requestBuilder = new RequestBuilder({
      IdSAL: sal.Id
    })

    this.documentiService.visualizzaSALAttivita(requestBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        this.downloadAllegato(null, sal, response);
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      }
    )
  }

  /**
   * callback fired when SAL update button is clicked
   * @param sal 
   */
  onUpdateSALClick(sal: ISal) {
    //cannot update first SAL
    if (sal.Id != this.objSALByAttivita.SAL[0].Id) {
      //get header translation
      this.translate.get("LBL_UPDATE_SAL").subscribe(res => {
        //open sal modal
        let ref = //open new sal modal
          this.dialogService.open(NewSalModalComponent, {
            data: {
              objSALByAttivita: this.objSALByAttivita,
              sal: sal
            },
            header: res,
            width: '50%'
          })

        // refresh sal list when modal is closed and SAL is updated
        ref.onClose.subscribe((SALSaved: ISal) => {
          if (SALSaved) {
            //refresh overriding old sal
            // find sal index into array
            let salIndex = this.objSALByAttivita.SAL.findIndex(sal => sal.Id == SALSaved.Id)
            // override sal
            if (salIndex > -1) {
              this.objSALByAttivita.SAL.splice(salIndex, 1, SALSaved)
            }
            this.checkObjAndSetField()
            this.getChartDat()
          }
        })
      })
    } else {
      this.alertUtil.showAlert('LBL_CANNOT_UPDATE_SAL')
    }
  }

  /**
   * callback fired when SAL delete button is clicked
   * @param sal 
   */
  onDeleteSALClick(sal: ISal) {
    //cannot delete first SAL
    if (sal.Id != this.objSALByAttivita.SAL[0].Id) {
      this.alertUtil.showConfirmationAlert("LBL_DELETE_SAL_CONFIRM", null, null, null, null, () => {
        this.deleteSAL(sal)
      })
    } else {
      this.alertUtil.showAlert('LBL_CANNOT_DELETE_SAL')
    }
  }

  /**
   * call WS to delete SAL
   * @param salToDelete 
   */
  deleteSAL(salToDelete: ISal) {
    let reqBuilder = new RequestBuilder({ Id: salToDelete.Id })
    this.attivitaService.deleteSALofAttivita(reqBuilder).subscribe(
      response => {
        Loading.isLoading = false
        if (response.data) {
          //remove SAL deleted if response OK
          this.alertUtil.showAlert('LBL_DELETE_SAL', null, null, null, () => {
            this.objSALByAttivita.SAL.forEach((sal, index) => {
              if (sal.Id == salToDelete.Id) {
                this.objSALByAttivita.SAL.splice(index, 1)
              }
            })
            this.checkObjAndSetField()
            this.getChartDat()
          })
        } else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        } else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        Loading.isLoading = false
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

}
